<template>
  <div class="text-contatos">
    <div v-for="(telefone, key) in contatos.telefones" :key="'phone-' + key">
      <span v-if="telefone.value">
        <font-awesome-icon
          icon="whatsapp"
          class="mr-2 text-green"
          style="font-size: 1.1rem"
          v-if="telefone.whatsapp"
        />{{ telefone.value | telefone }}
      </span>
    </div>
    <div v-for="(email, key) in contatos.emails" :key="'email-' + key">
      <span v-if="email.value">
        {{ email.value }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contatos: {
      type: Object,
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.text-contatos {
  font-size: 0.8em;
  line-height: 0.9rem;
}
</style>
